module.exports = __webpack_public_path__ + "img/arrow_left.5a65e484.svg";